import type { ThemeResources } from 'owa-theme-shared';
import { getStore } from '../store/store';

export default function getCopilotThemeResources(isDarkTheme: boolean): ThemeResources {
    return isDarkTheme
        ? getStore().options.darkThemeResources
        : getStore().options.lightThemeResources;
}
